import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {userService} from "../_services";

/**
 * This is a (private) route component wrapper that checks if authentication exists.
 * If yes, they're allowed
 * If no, they're redirected to signin page
 * Usage Note : Use <PrivateRoute when building up the protected routes
 * @param Component
 * @param rest
 * @returns {*}
 * @constructor
 */
export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        // check if a user exists in the authentication storage or not
        userService.getAuthUser()
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
    )} />
);